import { render, staticRenderFns } from "./MyActions.vue?vue&type=template&id=a2edd9e6&scoped=true&"
import script from "./MyActions.vue?vue&type=script&lang=js&"
export * from "./MyActions.vue?vue&type=script&lang=js&"
import style0 from "./MyActions.vue?vue&type=style&index=0&id=a2edd9e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2edd9e6",
  null
  
)

component.options.__file = "MyActions.vue"
export default component.exports